<template>
    <div class="aside nav-faq-categories">
        <b-button
            class="d-flex d-md-none faq-category-nav-toggler"
            v-b-toggle.nav-faq-categories-toggle
            active-class="active"
            variant="primary">
            <span class="header">
                <i class="fad fa-folder-tree"></i>
            {{$t('faq.categories')}}
            </span>
            <i class="fas fa-fw fa-chevron-down toggle-state-icon"></i>
        </b-button>
        <b-collapse
            class="faq-category-nav"
            id="nav-faq-categories-toggle"
            v-model="iscollaped"
            visible>
            <b-nav vertical>
                <b-nav-text class="d-none d-md-block faq-category-nav-header">
                    <i class="fad fa-folder-tree"></i>
                    {{$t('faq.categories')}}
                </b-nav-text>
                <b-nav-item
                    class="nav-link-faq-category"
                    v-for="category in categoriesIn"
                    :class="selectedCategoryIn === category.id && 'active'"
                    link-classes="faq-category-nav-link"
                    :key="category.id"
                    @click="updateSelectedCategory(category)">
                    {{ category.name }}
                </b-nav-item>
            </b-nav>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-faq-category-nav-component',
        props: {
            categoriesIn: {
                type: Array,
                required: true,
            },
            selectedCategoryIn: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                windowWidth: window.innerWidth,
                iscollaped: window.innerWidth >= 768,
            };
        },

        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            });
            this.onResize();
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },

        methods: {
            updateSelectedCategory(category) {
                this.$emit('update-selected-category', category);
            },

            onResize() {
                this.windowWidth = window.innerWidth;
                this.iscollaped = window.innerWidth >= 768;
            },
        },
    };
</script>

<style scoped lang="scss">
    .nav-faq-categories {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .faq-category-nav-toggler {
        align-items: center;
        justify-content: space-between;
        width: 100%;
        text-align: left;

        .toggle-state-icon {
            margin-left: auto;
            transform-origin: center;
            transition: all 0.8s ease;
        }

        &.not-collapsed {
            .toggle-state-icon {
                transform: rotate(-180deg);
            }
        }
    }

    .faq-category-nav {
        .faq-category-nav-header {
            background-color: var(--primary);
            color: $white;
            padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
            font-size: $base-font-size;
            border: 1px solid var(--primary);
            border-radius: 4px;
            line-height: 1.5;
        }

        .nav-link-faq-category {
            &:not(:last-child) {
                border-bottom: 3px dotted $border-color;
                padding-bottom: map-get($grid-gutter-spacing, 'five');
                margin-top: map-get($grid-gutter-spacing, 'five');
            }

            &:hover,
            &.active {
                a {
                    font-weight: $font-weight-bold;
                    color: var(--primaryDarker);
                }
            }
        }

        .nav-link {
            font-family: $headings-font-family;
            font-weight: $font-weight-medium;
        }
    }
</style>
